import {AdminTaskView, getAuthenticatedAdminThemisClient} from '@modifi/onboarding-api-clients'
import {CollectionFactory, Reducer} from '@modifi/redux'

const apiClient = getAuthenticatedAdminThemisClient()

const {actions, selectors, reducer} = CollectionFactory({
  reducerPath: ['data', 'tasks'],
  actionNamePrefix: 'data/tasks/collection',
  // @ts-ignore
  fetchRequest: (state, params: any) =>
    apiClient.Task.fetch({...params}).then(res => {
      const {_meta, tasks} = res.data()
      return {
        entities: tasks,
        meta: _meta,
      }
    }),
  entityPrimaryKeySelector: (entity: AdminTaskView) => entity.externalId!,
})

export default reducer as Reducer

export const selectTasksByParams = selectors.selectByKeyWindow as (
  state: Record<string, any>,
  params: any
) => AdminTaskView[]

export const selectTasksAreLoadingByParams = selectors.selectIsKeyWindowLoading as (
  state: Record<string, any>,
  params: any
) => boolean

const selectTaskMetaByParams = selectors.selectMetaByKeyWindow as (
  state: Record<string, any>,
  params: any
) => Record<string, any>

export const selectTasksTotalCountForParams = (state: Record<string, any>, params: any): number =>
  selectTaskMetaByParams(state, params)?.totalCount

export const selectTasksTotalPagesForParams = (state: Record<string, any>, params: any): number => {
  const maxPageIndex = selectTaskMetaByParams(state, params)?.maxPageIndex
  if (typeof maxPageIndex === 'number') {
    return maxPageIndex + 1
  }
  return maxPageIndex
}

export const aFetchTasksWithParams = (params: any): any => actions?.fetch(params)
